import Home from "@/components/views/home/HomeView";

export default [
  {
    path: "",
    name: "home",
    component: Home
  }
];
